module.exports = "<i class=\"icon icon-copy\" (click)=\"copyContent()\"></i>\n"